import { IssueService } from 'src/app/_services/issue/issue.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ProjectService } from 'src/app/_services/project/project.service';

@Component({
  selector: 'app-issues',
  templateUrl: './issues.component.html',
  styleUrls: ['./issues.component.scss']
})
export class IssuesComponent implements OnInit {
  issueForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  currentUser: any;
  currentProjectId: any;
  userDropdownList = [];
  getUserName: any;
  parentProjectId: any;
  isPMOLeadORManager: boolean = false;
  isAdministrator: boolean = false;
 
  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private issueService: IssueService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private route: ActivatedRoute,
    private projectService: ProjectService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs(); 
   
    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });
  
     this.issueForm = new FormGroup({
      id: new FormControl(''),
      projectId: new FormControl('', Validators.required),
      identifier: new FormControl(''),
      issueType: new FormControl('', Validators.required),
      description: new FormControl(''),
      priority: new FormControl('', Validators.required),
      //priority: new FormControl('',Validators.compose([ Validators.required ,Validators.pattern("^[1-5]*$")])),
      assignedToUserId: new FormControl('',Validators.required),
      assignedToUserName: new FormControl(''),
      department: new FormControl(''),
      status: new FormControl(''),
      trafficLight: new FormControl(''),
      action: new FormControl(''),
      resolution: new FormControl(''),
      creationDate: new FormControl('',Validators.required),
      targetResolutionDate: new FormControl('',Validators.required),
      finalResolutionDate: new FormControl('',Validators.required),
      createdByUserId: new FormControl(''),
      modifiedByUserId: new FormControl(''),
      createdByUserName: new FormControl(''),
      modifiedByUserName: new FormControl(''),
     })
    }
  

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');
    this.getAIssuesData();
    this.getUserList();
    this.getProjectById();
  }

  getProjectById(){
    this.projectService.getProjectById(this.currentProjectId).subscribe((response: any) =>{
      let lead = this.currentUser.id + " . " + this.currentUser.firstName + " " + this.currentUser.lastName;
      let creater = this.currentUser.firstName + " " + this.currentUser.lastName;
      let createrFullName = this.currentUser.firstName + " " + this.currentUser.middleName + " " + this.currentUser.lastName;
      if(response.projectManagerId === this.currentUser.id || response.projectController === lead || response.createdBy === creater || response.createdBy === createrFullName){
        this.isPMOLeadORManager = true;
      }
    });
  }

  getAIssuesData() {
    this.issueService.getIssues(this.currentProjectId).subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

   // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
   onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  // create column definitions  
  private createColumnDefs() {
    return [
    {
      headerName: "Project ID",
      field: "projectID",
      filter: true,
      editable: false,
      sortable: true,
      hide: true
    },
    {
      headerName: "Identifier",
      field: "identifier",
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: "IssueType",
      field: "issueType",
      filter: true,
      editable: false,
      sortable: true,
    },
    {
      headerName: "Description",
      field: "description",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }, 
    {
      headerName: "Priority",
      field: "priority",
      filter: true,
      editable: false,
      sortable: true,
    }, 
    {
      headerName: "Assigned To User",
      field: "assignedToUserName",
      filter: true,
      editable: false,
      sortable: true,
      
    },
    {
      headerName: "Department",
      field: "department",
      filter: true,
      editable: false,
      sortable: true,
      hide:true
    }, 
    {
      headerName: "Status",
      field: "status",
      filter: true,
      editable: false,
      sortable: true,
    }, 
    {
      headerName: "TrafficLight",
      field: "trafficLight",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    },
    {
      headerName: "Action",
      field: "action",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }, 
    {
      headerName: "Resolution",
      field: "resolution",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }, 
    {
      headerName: "Creation Date",
      field: "creationDate",
      filter: true,
      editable: false,
      sortable: true,
    },
    {
      headerName: "Target Resolution Date",
      field: "targetResolutionDate",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }, 
    {
      headerName: "Final Resolution Date",
      field: "finalResolutionDate",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }, 
    {
      headerName: "Created By UserId",
      field: "createdByUserId",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    },
    
    {
      headerName: "Modified By UserId",
      field: "modifiedByUserId",
      filter: true,
      editable: false,
      sortable: true,
      hide:true,
    }]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createIssue() {
    let details = {
      projectId: this.issueForm.get('projectId').value,
      identifier: this.issueForm.get('identifier').value,
      issueType: this.issueForm.get('issueType').value,
      description: this.issueForm.get('description').value,
      priority: this.issueForm.get('priority').value,
      assignedToUserId: this.issueForm.get('assignedToUserId').value.toString().includes(".") ? this.issueForm.get('assignedToUserId').value.split('.')[0].trim() : this.issueForm.get('assignedToUserId').value,
      assignedToUserName: this.issueForm.get('assignedToUserId').value.toString().includes(".") ? this.issueForm.get('assignedToUserId').value.split('.')[1].trim() : "",
      department: this.issueForm.get('department').value,
      status: this.issueForm.get('status').value,
      trafficLight: this.issueForm.get('trafficLight').value,
      action: this.issueForm.get('action').value,
      resolution: this.issueForm.get('resolution').value,
      creationDate: this.issueForm.get('creationDate').value,
      targetResolutionDate: this.issueForm.get('targetResolutionDate').value,
      finalResolutionDate: this.issueForm.get('finalResolutionDate').value,
    }
    this.issueService.createIssues(details).subscribe(response => {
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      this.getAIssuesData();
      $('#closeCreateModal').trigger("click");
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.issueService.deleteIssues(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }
  
  editOpenModal() {
    this.modeAction = 2;
    this.issueForm.patchValue(this.selectedCheckboxData[0]);
    this.issueForm.value.assignedToUserId = this.issueForm.value.assignedToUserId + ' . ' + this.issueForm.value.assignedToUserName;
    this.issueForm.value.createdByUserId = this.issueForm.value.createdByUserId + ' . ' + this.issueForm.value.createdByUserName;
    this.issueForm.value.modifiedByUserId = this.issueForm.value.modifiedByUserId + ' . ' + this.issueForm.value.modifiedByUserName;
    this.issueForm.patchValue(this.issueForm.value);
  }

  createOpenModal() {
    this.modeAction = 1;
    this.issueForm.reset();
    this.issueForm.patchValue({
      id:'',
      projectId: this.currentProjectId,
      identifier:'',
      issueType:'',
      description:'',
      priority:'',
      assignedToUserId:'',
      assignedToUserName: '',
      department:'',
      status:'',
      trafficLight:'',
      action:'',
      resolution:'',
      creationDate:'',
      targetResolutionDate:'',
      finalResolutionDate:'',
      createdByUserId:'',
      modifiedByUserId:'',
    })
  }

  updateIssues() {

    let details = {
      projectId: this.issueForm.get('projectId').value,
      identifier: this.issueForm.get('identifier').value,
      issueType: this.issueForm.get('issueType').value,
      description: this.issueForm.get('description').value,
      priority: this.issueForm.get('priority').value,
      assignedToUserId: this.issueForm.get('assignedToUserId').value.toString().includes(".") ? this.issueForm.get('assignedToUserId').value.split('.')[0].trim() : this.issueForm.get('assignedToUserId').value,
      assignedToUserName: this.issueForm.get('assignedToUserId').value.toString().includes(".") ? this.issueForm.get('assignedToUserId').value.split('.')[1].trim() : "",
      department: this.issueForm.get('department').value,
      status: this.issueForm.get('status').value,
      trafficLight: this.issueForm.get('trafficLight').value,
      action: this.issueForm.get('action').value,
      resolution: this.issueForm.get('resolution').value,
      creationDate: this.issueForm.get('creationDate').value,
      targetResolutionDate: this.issueForm.get('targetResolutionDate').value,
      finalResolutionDate: this.issueForm.get('finalResolutionDate').value,
      createdByUserId: this.issueForm.get('createdByUserId').value.toString().includes(".") ? this.issueForm.get('createdByUserId').value.split('.')[0].trim() : this.issueForm.get('createdByUserId').value,
      createdByUserName: this.issueForm.get('createdByUserId').value.toString().includes(".") ? this.issueForm.get('createdByUserId').value.split('.')[1].trim() : "",
      modifiedByUserId: this.issueForm.get('modifiedByUserId').value.toString().includes(".") ? this.issueForm.get('modifiedByUserId').value.split('.')[0].trim() : this.issueForm.get('modifiedByUserId').value,
      modifiedByUserName: this.issueForm.get('modifiedByUserId').value.toString().includes(".") ? this.issueForm.get('modifiedByUserId').value.split('.')[1].trim() : "",
    }

    this.issueService.updateIssues(details, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getAIssuesData();
      this.selectedCheckboxData = []
      $('#closeCreateModal').trigger("click");
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].issueType} ${this.selectedCheckboxData[i].projectId}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].projectId} ${this.selectedCheckboxData[i].lastName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].issueType} ${this.selectedCheckboxData[i].projectId}`;
    }
  }

  deleteIssueList() {
    this.issueService. deleteIssues(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getAIssuesData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteLead').trigger("click");
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.issueForm.controls;
  }

  openProjectTab(param) {
    if(this.parentProjectId){
      this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
    }
    else{
      this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
    }
  }

  backToMyProject() {
    if(this.parentProjectId){
      this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project-list'], { queryParams: { projectID: this.parentProjectId} });
    }else{
      this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
    }
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

}
